export {
  CHANGE_UPLOAD_POST_FILE,
  CLEAR_CURRENT_REPOST,
  CLEAR_EDITING_POST,
  GET_POST_COMMENT_WS,
  GET_POST_COMMENT_WS_FAILED,
  GET_POST_COMMENT_WS_SUCCESS,
  LIKE_POST,
  LIKE_POST_FAILED,
  LIKE_POST_SUCCESS,
  SET_CURRENT_REPOST,
  SET_EDITING_POST,
  SET_NTF_STATUS,
  SET_NTF_STATUS_FAILED,
  SET_NTF_STATUS_SUCCESS,
  UPLOAD_POST_FILE,
  UPLOAD_POST_FILE_FAILED,
  UPLOAD_POST_FILE_SUCCESS,
} from './postConstants';

export * from './chats';

export * as savedSearchConstants from './savedSearchConstants';

export * as callsConstants from './calls';

export { CLEAR_SEARCH_DATA } from './searchConstants';

export const VERIFY_NEW_ACCOUNT = 'VERIFY_NEW_ACCOUNT';

export const HANDLE_RESTORE_ROUTE = 'HANDLE_RESTORE_ROUTE';
export const HANDLE_RESTORE_ROUTE_SUCCESS = 'HANDLE_RESTORE_ROUTE_SUCCESS';
export const HANDLE_RESTORE_ROUTE_FAILED = 'HANDLE_RESTORE_ROUTE_FAILED';

export const RESTORE_ACCOUNT_EMAIL = 'RESTORE_ACCOUNT_EMAIL';
export const RESTORE_ACCOUNT_EMAIL_SUCCESS = 'RESTORE_ACCOUNT_EMAIL_SUCCESS';
export const RESTORE_ACCOUNT_EMAIL_FAILED = 'RESTORE_ACCOUNT_EMAIL_FAILED';

export const RESTORE_ACCOUNT_PASSWORD = 'RESTORE_ACCOUNT_PASSWORD';
export const RESTORE_ACCOUNT_PASSWORD_SUCCESS = 'RESTORE_ACCOUNT_PASSWORD_SUCCESS';
export const RESTORE_ACCOUNT_PASSWORD_FAILED = 'RESTORE_ACCOUNT_PASSWORD_FAILED';

export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const REQUEST_LOGIN_FAILED = 'REQUEST_LOGIN_FAILED';

export const REQUEST_SIGNUP = 'REQUEST_SIGNUP';
export const REQUEST_SIGNUP_SUCCESS = 'REQUEST_SIGNUP_SUCCESS';
export const REQUEST_SIGNUP_FAILED = 'REQUEST_SIGNUP_FAILED';
export const RESEND_APPROVE_EMAIL = 'RESEND_APPROVE_EMAIL';

export const CLEAR_PDF_FILE = 'CLEAR_PDF_FILE';

export const HIDE_PASSWORD_SUCCESS = 'HIDE_PASSWORD_SUCCESS';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const SET_SEARCH_CHANGED = 'SET_SEARCH_CHANGED';
export const CHANGE_SCREEN_ORIENTATION = 'CHANGE_SCREEN_ORIENTATION';

export const SEND_PENDING_DATA = 'SEND_PENDING_DATA';
export const CHANGE_SEARCH_FILTER = 'CHANGE_SEARCH_FILTER';
export const SHOW_FOOTER_NAVBAR = 'SHOW_FOOTER_NAVBAR';
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';

export const REQUEST_LOGOUT = 'REQUEST_LOGOUT';
export const REQUEST_LOGOUT_SUCCESS = 'REQUEST_LOGOUT_SUCCESS';
export const REQUEST_LOGOUT_FAILED = 'REQUEST_LOGOUT_FAILED';

export const REQUEST_USER = 'REQUEST_USER';
export const REQUEST_USER_SUCCESS = 'REQUEST_USER_SUCCESS';
export const REQUEST_USER_FAILED = 'REQUEST_USER_FAILED';

export const REQUEST_PERSONAL_INFO = 'REQUEST_PERSONAL_INFO';
export const REQUEST_PERSONAL_INFO_SUCCESS = 'REQUEST_PERSONAL_INFO_SUCCESS';
export const REQUEST_PERSONAL_INFO_FAILED = 'REQUEST_PERSONAL_INFO_FAILED';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';

export const UPDATE_IMAGE = 'UPDATE_IMAGE';
export const UPDATE_IMAGE_SUCCESS = 'UPDATE_IMAGE_SUCCESS';
export const UPDATE_IMAGE_FAILED = 'UPDATE_IMAGE_FAILED';

export const UPDATE_BANNER = 'UPDATE_BANNER';
export const UPDATE_BANNER_SUCCESS = 'UPDATE_BANNER_SUCCESS';
export const UPDATE_BANNER_FAILED = 'UPDATE_BANNER_FAILED';

export const REMOVE_IMAGE = 'REMOVE_IMAGE';
export const REMOVE_IMAGE_SUCCESS = 'REMOVE_IMAGE_SUCCESS';
export const REMOVE_IMAGE_FAILED = 'REMOVE_IMAGE_FAILED';

export const REMOVE_BANNER = 'REMOVE_BANNER';
export const REMOVE_BANNER_SUCCESS = 'REMOVE_BANNER_SUCCESS';
export const REMOVE_BANNER_FAILED = 'REMOVE_BANNER_FAILED';

export const ADD_SEARCH_STRING = 'ADD_SEARCH_STRING';

export const REQUEST_SUBSCRIPTION = 'REQUEST_SUBSCRIPTION';
export const REQUEST_SUBSCRIPTION_SUCCESS = 'REQUEST_SUBSCRIPTION_SUCCESS';
export const REQUEST_SUBSCRIPTION_FAILED = 'REQUEST_SUBSCRIPTION_FAILED';

export const SUBSCRIBE = 'SUBSCRIBE';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_FAILED = 'SUBSCRIBE_FAILED';
export const GET_FOLLOWINGS = 'GET_FOLLOWINGS';
export const GET_FOLLOWINGS_SUCCESS = 'GET_FOLLOWINGS_SUCCESS';
export const GET_FOLLOWINGS_FAILED = 'GET_FOLLOWINGS_FAILED';
export const CLEAR_FOLLOWINGS = 'CLEAR_FOLLOWINGS';
export const GET_FOLLOWERS = 'GET_FOLLOWERS';
export const GET_FOLLOWERS_SUCCESS = 'GET_FOLLOWERS_SUCCESS';
export const GET_FOLLOWERS_FAILED = 'GET_FOLLOWERS_FAILED';
export const CLEAR_FOLLOWERS = 'CLEAR_FOLLOWERS';
export const CHANGE_SUBSCRIPTION = 'CHANGE_SUBSCRIPTION';
export const CHANGE_SUBSCRIPTION_SUCCESS = 'CHANGE_SUBSCRIPTION_SUCCESS';
export const CHANGE_SUBSCRIPTION_FAILED = 'CHANGE_SUBSCRIPTION_FAILED';

export const CHANGE_THEME = 'CHANGE_THEME';
export const CHANGE_THEME_SUCCESS = 'CHANGE_THEME_SUCCESS';
export const CHANGE_THEME_FAILED = 'CHANGE_THEME_FAILED';

export const REQUEST_THEME = 'REQUEST_THEME';
export const REQUEST_THEME_SUCCESS = 'REQUEST_THEME_SUCCESS';
export const REQUEST_THEME_FAILED = 'REQUEST_THEME_FAILED';

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILED = 'UPDATE_PASSWORD_FAILED';

export const REQUEST_USER_NEWS = 'REQUEST_USER_NEWS';
export const REQUEST_USER_NEWS_SUCCESS = 'REQUEST_USER_NEWS_SUCCESS';
export const REQUEST_USER_NEWS_FAILED = 'REQUEST_USER_NEWS_FAILED';

export const REQUEST_POSTS_BY_OWNER = 'REQUEST_POSTS_BY_OWNER';
export const REQUEST_POSTS_BY_OWNER_SUCCESS = 'REQUEST_POSTS_BY_OWNER_SUCCESS';
export const REQUEST_POSTS_BY_OWNER_FAILED = 'REQUEST_POSTS_BY_OWNER_FAILED';

export const REQUEST_OWN_FEEDS = 'REQUEST_OWN_FEEDS';
export const REQUEST_OWN_FEEDS_SUCCESS = 'REQUEST_OWN_FEEDS_SUCCESS';
export const REQUEST_OWN_FEEDS_FAILED = 'REQUEST_OWN_FEEDS_FAILED';

export const REQUEST_USER_IMAGE = 'REQUEST_USER_IMAGE';
export const REQUEST_USER_IMAGE_SUCCESS = 'REQUEST_USER_IMAGE_SUCCESS';
export const REQUEST_USER_IMAGE_FAILED = 'REQUEST_USER_IMAGE_FAILED';

export const REQUEST_PDF = 'REQUEST_PDF';
export const REQUEST_PDF_SUCCESS = 'REQUEST_PDF_SUCCESS';
export const REQUEST_PDF_FAILED = 'REQUEST_PDF_FAILED';

export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const IS_SHOW_SEARCH_DETAILS = 'IS_SHOW_SEARCH_DETAILS';
export const HIDE_LEFT_BAR = 'HIDE_LEFT_BAR';
export const HIDE_RIGHT_BAR = 'HIDE_RIGHT_BAR';

export const GET_NAUSEARCH_ITEM = 'GET_NAUSEARCH_ITEM';
export const GET_NAUSEARCH_ITEM_SUCCESS = 'GET_NAUSEARCH_ITEM_SUCCESS';
export const GET_NAUSEARCH_ITEM_FAILED = 'GET_NAUSEARCH_ITEM_FAILED';

export const SET_NAUSEARCH_REQUEST_MESSAGE = 'SET_NAUSEARCH_REQUEST_MESSAGE';

export const REQUEST_SEARCH_RESULTS = 'REQUEST_SEARCH_RESULTS';
export const REQUEST_SEARCH_RESULTS_SUCCESS = 'REQUEST_SEARCH_RESULTS_SUCCESS';
export const REQUEST_SEARCH_RESULTS_FAILED = 'REQUEST_SEARCH_RESULTS_FAILED';

export const REQUEST_SEARCH_DETAILS_RESULTS = 'REQUEST_SEARCH_DETAILS_RESULTS';
export const REQUEST_SEARCH_DETAILS_RESULTS_SUCCESS = 'REQUEST_SEARCH_DETAILS_RESULTS_SUCCESS';
export const REQUEST_SEARCH_DETAILS_RESULTS_FAILED = 'REQUEST_SEARCH_DETAILS_RESULTS_FAILED';

export const REQUEST_RUBRIC = 'REQUEST_RUBRIC';
export const REQUEST_RUBRIC_SUCCESS = 'REQUEST_RUBRIC_SUCCESS';
export const REQUEST_TYPE_SUCCESS = 'REQUEST_RUBRIC_SUCCESS';
export const REQUEST_RUBRIC_FAILED = 'REQUEST_RUBRIC_FAILED';

export const SET_BROWSER_ONLINE = 'SET_BROWSER_ONLINE';
export const CHECK_BROWSER_ONLINE = 'CHECK_BROWSER_ONLINE';

export const VALIDATE_AUTH = 'VALIDATE_AUTH';
export const CHANGE_LOCATION = 'CHANGE_LOCATION';
export const CLEAR_SIGNUP_DATA = 'CLEAR_SIGNUP_DATA';
export const CLEAR_RESTORE_DATA = 'CLEAR_RESTORE_DATA';

export const CALL_START = 'CALL_START';
export const CALL_RECEIVE = 'CALL_RECEIVE';
export const CALL_HANDLE_INCOMING = 'CALL_HANDLE_INCOMING';
export const CALL_HANDLE_INCOMING_SUCCESS = 'CALL_HANDLE_INCOMING_SUCCESS';
export const CALL_HANDLE_INCOMING_FAILED = 'CALL_HANDLE_INCOMING_FAILED';
export const CALL_ACTIVATED = 'CALL_ACTIVATED';
export const CALL_TERMINATE = 'CALL_TERMINATE';
export const CALL_REQUEST_JOIN = 'CALL_REQUEST_JOIN';
export const CALL_REDIAL = 'CALL_REDIAL';
export const CALL_MINIFY = 'CALL_MINIFY';

export const CLEAR_FF_DATA = 'CLEAR_FF_DATA';
export const SET_STREAM = 'SET_STREAM';
export const ADD_STREAM_DETECTION = 'ADD_STREAM_DETECTION';
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT';
export const DELETE_PARTICIPANT = 'DELETE_PARTICIPANT';
export const UPDATE_STREAM_DETECTION = 'UPDATE_STREAM_DETECTION';
export const DELETE_STREAM_DETECTION = 'DELETE_STREAM_DETECTION';
export const MUTE_CAMERA = 'MUTE_CAMERA';
export const MUTE_MICRO = 'MUTE_MICRO';

export const SET_AUDIO_DEVICES = 'SET_AUDIO_DEVICES';
export const SET_VIDEO_DEVICES = 'SET_VIDEO_DEVICES';
export const SET_CAMERA = 'SET_CAMERA';
export const SET_MICROPHONE = 'SET_MICROPHONE';
export const CLEAR_HARDWARE_DEVICES = 'CLEAR_HARDWARE_DEVICES';

// popup
export const POPUP_OPEN = 'POPUP_OPEN ';
export const POPUP_CLOSE = 'POPUP_CLOSE ';

// profile
export const POST_PROFILE_SETTINGS = 'POST_PROFILE_SETTINGS';
export const POST_PROFILE_SETTINGS_SUCCESS = 'POST_PROFILE_SETTINGS_SUCCESS';
export const POST_PROFILE_SETTINGS_FAILED = 'POST_PROFILE_SETTINGS_FAILED';
export const SEARCH_ORGANIZATION = 'SEARCH_ORGANIZATION';
export const SEARCH_ORGANIZATION_SUCCESS = 'SEARCH_ORGANIZATION_SUCCESS';
export const SEARCH_ORGANIZATION_FAILED = 'SEARCH_ORGANIZATION_FAILED';
export const GET_POSITIONS = 'GET_POSITIONS';
export const GET_POSITIONS_SUCCESS = 'GET_POSITIONS_SUCCESS';
export const GET_POSITIONS_FAILED = 'GET_POSITIONS_FAILED';
export const GET_LABOR_ACIVITY = 'GET_LABOR_ACIVITY';
export const GET_LABOR_ACIVITY_SUCCESS = 'GET_LABOR_ACIVITY_SUCCESS';
export const GET_LABOR_ACIVITY_FAILED = 'GET_LABOR_ACIVITY_FAILED';
export const POST_LABOR_ACIVITY = 'POST_LABOR_ACIVITY';
export const POST_LABOR_ACIVITY_SUCCESS = 'POST_LABOR_ACIVITY_SUCCESS';
export const POST_LABOR_ACIVITY_FAILED = 'POST_LABOR_ACIVITY_FAILED';
export const EDIT_LABOR_ACIVITY = 'EDIT_LABOR_ACIVITY';
export const EDIT_LABOR_ACIVITY_SUCCESS = 'EDIT_LABOR_ACIVITY_SUCCESS';
export const EDIT_LABOR_ACIVITY_FAILED = 'EDIT_LABOR_ACIVITY_FAILED';
export const DELETE_LABOR_ACIVITY = 'DELETE_LABOR_ACIVITY';
export const DELETE_LABOR_ACIVITY_SUCCESS = 'DELETE_LABOR_ACIVITY_SUCCESS';
export const DELETE_LABOR_ACIVITY_FAILED = 'DELETE_LABOR_ACIVITY_FAILED';
export const DELETE_EDUCATION = 'DELETE_EDUCATION';
export const DELETE_EDUCATION_SUCCESS = 'DELETE_EDUCATION_SUCCESS';
export const DELETE_EDUCATION_FAILED = 'DELETE_EDUCATION_FAILED';
export const GET_ACTIVITY_AREAS = 'GET_ACTIVITY_AREAS';
export const GET_ACTIVITY_AREAS_FAILED = 'GET_ACTIVITY_AREAS_FAILED';
export const GET_ACTIVITY_AREAS_SUCCESS = 'GET_ACTIVITY_AREAS_SUCCESS';
export const GET_EDUCATION_TYPES = 'GET_EDUCATION_TYPES';
export const GET_EDUCATION_TYPES_SUCCESS = 'GET_EDUCATION_TYPES_SUCCESS';
export const GET_EDUCATION_TYPES_FAILED = 'GET_EDUCATION_TYPES_FAILED';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_FAILED = 'GET_COUNTRIES_FAILED';
export const FIND_CITIES = 'FIND_CITIES';
export const FIND_CITIES_SUCCESS = 'FIND_CITIES_SUCCESS';
export const FIND_CITIES_FAILED = 'FIND_CITIES_FAILED';
export const GET_EDUCATION = 'GET_EDUCATION';
export const GET_EDUCATION_SUCCESS = 'GET_EDUCATION_SUCCESS';
export const GET_EDUCATION_FAILED = 'GET_EDUCATION_FAILED';
export const POST_EDUCATION = 'POST_EDUCATION';
export const POST_EDUCATION_SUCCESS = 'POST_EDUCATION_SUCCESS';
export const POST_EDUCATION_FAILED = 'POST_EDUCATION_FAILED';
export const EDIT_EDUCATION = 'EDIT_EDUCATION';
export const EDIT_EDUCATION_SUCCESS = 'EDIT_EDUCATION_SUCCESS';
export const EDIT_EDUCATION_FAILED = 'EDIT_EDUCATION_FAILED';
export const GET_DEGREES = 'GET_DEGREES';
export const GET_DEGREES_SUCCESS = 'GET_DEGREES_SUCCESS';
export const GET_DEGREES_FAILED = 'GET_DEGREES_FAILED';
export const POST_DEGREES = 'POST_DEGREES';
export const POST_DEGREES_SUCCESS = 'POST_DEGREES_SUCCESS';
export const POST_DEGREES_FAILED = 'POST_DEGREES_FAILED';
export const EDIT_DEGREES = 'EDIT_DEGREES';
export const EDIT_DEGREES_SUCCESS = 'EDIT_DEGREES_SUCCESS';
export const EDIT_DEGREES_FAILED = 'EDIT_DEGREES_FAILED';
export const GET_CONTACTS = 'GET_CONTACTS';
export const GET_CONTACTS_SUCCESS = 'GET_CONTACTS_SUCCESS';
export const GET_CONTACTS_FAILED = 'GET_CONTACTS_FAILED';
export const POST_CONTACTS = 'POST_CONTACTS';
export const POST_CONTACTS_SUCCESS = 'POST_CONTACTS_SUCCESS';
export const POST_CONTACTS_FAILED = 'POST_CONTACTS_FAILED';
export const GET_SCIENTIFIC_INTERESTS = 'GET_SCIENTIFIC_INTERESTS';
export const GET_SCIENTIFIC_INTERESTS_SUCCESS = 'GET_SCIENTIFIC_INTERESTS_SUCCESS';
export const GET_SCIENTIFIC_INTERESTS_FAILED = 'GET_SCIENTIFIC_INTERESTS_FAILED';
export const POST_SCIENTIFIC_INTERESTS = 'POST_SCIENTIFIC_INTERESTS';
export const POST_SCIENTIFIC_INTERESTS_SUCCESS = 'POST_SCIENTIFIC_INTERESTS_SUCCESS';
export const POST_SCIENTIFIC_INTERESTS_FAILED = 'POST_SCIENTIFIC_INTERESTS_FAILED';
export const GET_USER_AUTHORS = 'GET_USER_AUTHORS';
export const GET_USER_AUTHORS_SUCCESS = 'GET_USER_AUTHORS_SUCCESS';
export const GET_USER_AUTHORS_FAILED = 'GET_USER_AUTHORS_FAILED';
export const POST_OBJ_IDENTIFIERS = 'POST_OBJ_IDENTIFIERS';
export const POST_OBJ_IDENTIFIERS_SUCCESS = 'POST_OBJ_IDENTIFIERS_SUCCESS';
export const POST_OBJ_IDENTIFIERS_FAILED = 'POST_OBJ_IDENTIFIERS_FAILED';
export const GET_UPLOADS = 'GET_UPLOADS';
export const GET_UPLOADS_SUCCESS = 'GET_UPLOADS_SUCCESS';
export const GET_UPLOADS_FAILED = 'GET_UPLOADS_FAILED';
export const STOP_EDIT_UPLOAD_ITEM = 'STOP_EDIT_UPLOAD_ITEM';
export const EDIT_UPLOAD_ITEM = 'EDIT_UPLOAD_ITEM';
export const EDIT_UPLOAD_ITEM_SUCCESS = 'EDIT_UPLOAD_ITEM_SUCCESS';
export const EDIT_UPLOAD_ITEM_FAILED = 'EDIT_UPLOAD_ITEM_FAILED';
export const POST_UPLOAD = 'POST_UPLOAD';
export const POST_UPLOAD_SUCCESS = 'POST_UPLOAD_SUCCESS';
export const POST_UPLOAD_FAILED = 'POST_UPLOAD_FAILED';
export const DELETE_UPLOAD = 'DELETE_UPLOAD';
export const DELETE_UPLOAD_SUCCESS = 'DELETE_UPLOAD_SUCCESS';
export const DELETE_UPLOAD_FAILED = 'DELETE_UPLOAD_FAILED';
export const PUT_UPLOAD_ITEM = 'PUT_UPLOAD_ITEM';
export const PUT_UPLOAD_ITEM_SUCCESS = 'PUT_UPLOAD_ITEM_SUCCESS';
export const PUT_UPLOAD_ITEM_FAILED = 'PUT_UPLOAD_ITEM_FAILED';
export const PUBLISH_UPLOAD_ITEM = 'PUBLISH_UPLOAD_ITEM';
export const PUBLISH_UPLOAD_ITEM_FAILED = 'PUBLISH_UPLOAD_ITEM_FAILED';
export const PUBLISH_UPLOAD_ITEM_SUCCESS = 'PUBLISH_UPLOAD_ITEM_SUCCESS';
export const GET_CLS_ITEMS = 'GET_CLS_ITEMS';
export const FIND_CLS_ITEMS = 'FIND_CLS_ITEMS';
export const GET_UPLOAD_CATALOG = 'GET_UPLOAD_CATALOG';
export const GET_UPLOAD_FILE_EXTENTIONS = 'GET_UPLOAD_FILE_EXTENTIONS';
export const GET_UPLOAD_FILE_EXTENTIONS_SUCCESS = 'GET_UPLOAD_FILE_EXTENTIONS_SUCCESS';
export const GET_UPLOAD_FILE_EXTENTIONS_FAILED = 'GET_UPLOAD_FILE_EXTENTIONS_FAILED';
export const GET_UPLOAD_FILE_MIME = 'GET_UPLOAD_FILE_MIME';
export const GET_UPLOAD_FILE_MIME_SUCCESS = 'GET_UPLOAD_FILE_MIME_SUCCESS';
export const GET_UPLOAD_FILE_MIME_FAILED = 'GET_UPLOAD_FILE_MIME_FAILED';
export const GET_PUBLICATION_TYPE = 'GET_PUBLICATION_TYPE';
export const GET_PUBLICATION_TYPE_SUCCESS = 'GET_PUBLICATION_TYPE_SUCCESS';
export const GET_PUBLICATION_TYPE_FAILED = 'GET_PUBLICATION_TYPE_FAILED';
export const GET_PUBLICATION_THEMATIC = 'GET_PUBLICATION_THEMATIC';
export const GET_PUBLICATION_THEMATIC_SUCCESS = 'GET_PUBLICATION_THEMATIC_SUCCESS';
export const GET_PUBLICATION_THEMATIC_FAILED = 'GET_PUBLICATION_THEMATIC_FAILED';
export const GET_SCIENCE_FIELD = 'GET_SCIENCE_FIELD';
export const GET_SCIENCE_FIELD_SUCCESS = 'GET_SCIENCE_FIELD_SUCCESS';
export const GET_SCIENCE_FIELD_FAILED = 'GET_SCIENCE_FIELD_FAILED';
export const GET_SCIENCE_AREA = 'GET_SCIENCE_AREA';
export const GET_SCIENCE_AREA_SUCCESS = 'GET_SCIENCE_AREA_SUCCESS';
export const GET_SCIENCE_AREA_FAILED = 'GET_SCIENCE_AREA_FAILED';
export const GET_LANGUAGES = 'GET_LANGUAGES';
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS';
export const GET_LANGUAGES_FAILED = 'GET_LANGUAGES_FAILED';
export const GET_AUTHORSHIP_TYPES = 'GET_AUTHORSHIP_TYPES';
export const GET_AUTHORSHIP_TYPES_SUCCESS = 'GET_AUTHORSHIP_TYPES_SUCCESS';
export const GET_AUTHORSHIP_TYPES_FAILED = 'GET_AUTHORSHIP_TYPES_FAILED';
export const GET_IDENTITY_SYSTEM = 'GET_IDENTITY_SYSTEM';
export const GET_IDENTITY_SYSTEM_SUCCESS = 'GET_IDENTITY_SYSTEM_SUCCESS';
export const GET_IDENTITY_SYSTEM_FAILED = 'GET_IDENTITY_SYSTEM_FAILED';
export const GET_ACCESS_LEVEL = 'GET_ACCESS_LEVEL';
export const GET_ACCESS_LEVEL_SUCCESS = 'GET_ACCESS_LEVEL_SUCCESS';
export const GET_ACCESS_LEVEL_FAILED = 'GET_ACCESS_LEVEL_FAILED';
export const GET_UPLOAD_ITEM_TYPES = 'GET_UPLOAD_ITEM_TYPES';
export const GET_UPLOAD_ITEM_TYPES_SUCCESS = 'GET_UPLOAD_ITEM_TYPES_SUCCESS';
export const GET_UPLOAD_ITEM_TYPES_FAILED = 'GET_UPLOAD_ITEM_TYPES_FAILED';
export const GET_CONTENT_TYPES = 'GET_CONTENT_TYPES';
export const GET_CONTENT_TYPES_SUCCESS = 'GET_CONTENT_TYPES_SUCCESS';
export const GET_CONTENT_TYPES_FAILED = 'GET_CONTENT_TYPES_FAILED';
export const SET_LOADING_CATALOGS = 'SET_LOADING_CATALOGS';
export const FIND_AUTHORS = 'FIND_AUTHORS';
export const FIND_AUTHORS_SUCCESS = 'FIND_AUTHORS_SUCCESS';
export const FIND_AUTHORS_FAILED = 'FIND_AUTHORS_FAILED';
export const SWITCH_UPLOAD_LIST_FILTER = 'SWITCH_UPLOAD_LIST_FILTER';
export const SWITCH_UPLOAD_LIST_FILTER_SUCCESS = 'SWITCH_UPLOAD_LIST_FILTER_SUCCESS';
export const SWITCH_UPLOAD_LIST_FILTER_FAILED = 'SWITCH_UPLOAD_LIST_FILTER_FAILED';

export const CREATE_POST = 'CREATE_POST';
export const CREATE_POST_SUCCESS = 'CREATE_POST_SUCCESS';
export const CREATE_POST_FAILED = 'CREATE_POST_FAILED';
export const GET_POST = 'GET_POST';
export const GET_POST_SUCCESS = 'GET_POST_SUCCESS';
export const GET_POST_FAILED = 'GET_POST_FAILED';
export const GET_POSTS = 'GET_POSTS';
export const GET_POSTS_SUCCESS = 'GET_POSTS_SUCCESS';
export const GET_POSTS_FAILED = 'GET_POSTS_FAILED';
export const UPDATE_POST = 'UPDATE_POST';
export const UPDATE_POST_SUCCESS = 'UPDATE_POST_SUCCESS';
export const UPDATE_POST_FAILED = 'UPDATE_POST_FAILED';
export const UPDATE_COMMENT_WS = 'UPDATE_COMMENT_WS';
export const UPDATE_POST_WS = 'UPDATE_POST_WS';
export const UPDATE_POST_WS_SUCCESS = 'UPDATE_POST_WS_SUCCESS';
export const UPDATE_POST_WS_FAILED = 'UPDATE_POST_WS_FAILED';
export const UPDATE_POST_STATS_WS = 'UPDATE_POST_STATS_WS';
export const DELETE_POST = 'DELETE_POST';
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS';
export const DELETE_POST_FAILED = 'DELETE_POST_FAILED';
export const LINK_FILES = 'LINK_FILES';
export const LINK_FILES_SUCCESS = 'LINK_FILES_SUCCESS';
export const LINK_FILES_FAILED = 'LINK_FILES_FAILED';
export const UNLINK_FILES = 'LINK_FILES';
export const UNLINK_FILES_SUCCESS = 'LINK_FILES_SUCCESS';
export const UNLINK_FILES_FAILED = 'LINK_FILES_FAILED';

export const GET_COMMENT = 'GET_COMMENT';
export const GET_COMMENTS = 'GET_COMMENTS';
export const GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS';
export const GET_COMMENTS_FAILED = 'GET_COMMENTS_FAILED';
export const POST_COMMENT = 'POST_COMMENT';
export const POST_COMMENT_SUCCESS = 'POST_COMMENT_SUCCESS';
export const POST_COMMENT_FAILED = 'POST_COMMENT_FAILED';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_FAILED = 'UPDATE_COMMENT_FAILED';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_FAILED = 'DELETE_COMMENT_FAILED';
export const LIKE_COMMENT = 'LIKE_COMMENT';
export const LIKE_COMMENT_SUCCESS = 'LIKE_COMMENT_SUCCESS';
export const LIKE_COMMENT_FAILED = 'LIKE_COMMENT_FAILED';

export const GET_SETTINGS_MODEL = 'GET_SETTINGS_MODEL';
export const GET_SETTINGS_MODEL_SUCCESS = 'GET_SETTINGS_MODEL_SUCCESS';
export const GET_SETTINGS_MODEL_FAILED = 'GET_SETTINGS_MODEL_FAILED';

export const DELETE_FOLLOWER = 'DELETE_FOLLOWER';
export const DELETE_FOLLOWER_SUCCESS = 'DELETE_FOLLOWER_SUCCESS';
export const DELETE_FOLLOWER_FAILED = 'DELETE_FOLLOWER_FAILED';

export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';

export const CREATE_ADDRESS = 'CREATE_ADDRESS';
export const CREATE_ADDRESS_FAILED = 'CREATE_ADDRESS_FAILED';
export const CREATE_ADDRESS_SUCCESS = 'CREATE_ADDRESS_SUCCESS';

export const EDIT_ADDRESS = 'EDIT_ADDRESS';
export const EDIT_ADDRESS_FAILED = 'EDIT_ADDRESS_FAILED';
export const EDIT_ADDRESS_SUCCESS = 'EDIT_ADDRESS_SUCCESS';

export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const DELETE_ADDRESS_FAILED = 'DELETE_ADDRESS_FAILED';
export const DELETE_ADDRESS_SUCCESS = 'DELETE_ADDRESS_SUCCESS';

export const GET_SETTINGS_ACCESS_LEVELS = 'GET_SETTINGS_ACCESS_LEVELS';
export const GET_SETTINGS_ACCESS_LEVELS_FAILED = 'GET_SETTINGS_ACCESS_LEVELS_FAILED';
export const GET_SETTINGS_ACCESS_LEVELS_SUCCESS = 'GET_SETTINGS_ACCESS_LEVELS_SUCCESS';

export const NAUSEARCH_REQUEST = 'NAUSEARCH_REQUEST';
export const NAUSEARCH_REQUEST_FAILED = 'NAUSEARCH_REQUEST_FAILED';
export const NAUSEARCH_REQUEST_SUCCESS = 'NAUSEARCH_REQUEST_SUCCESS';

export const SET_NAUSEARCH_ITEM = 'SET_NAUSEARCH_ITEM';

//search
export const TOGGLE_SEARCH_ACTIVE = 'TOGGLE_SEARCH_ACTIVE';
export const SET_RIGHT_SIDEBAR_VISIBLE = 'SET_RIGHT_SIDEBAR_VISIBLE';

//searchForm
export const SET_SEARCH_FORM = 'SET_SEARCH_FORM';
export const RESET_SEARCH_FORM = 'RESET_SEARCH_FORM';

export const UPDATE_FEED_POST_REACTIONS = 'UPDATE_FEED_POST_REACTIONS';
